import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  TREATMENT_OPTIONS,
  TREATMENT_OPTIONS_TYPE,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentOptions'
import { TREATMENT_RECOMMENDATION_TIER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentRecommendationsConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const livemagenta: GetCustomerCopyFunc = () => {
  const premiseHealthOnsiteTherapyConfiguration = {
    analyticsName: 'Premise Health',
    title: (
      <FormattedMessage
        defaultMessage='T-Mobile Onsite Health Center - Premise Health Providers'
        description='Title for "T-Mobile Onsite Health Center - Premise Health Providers" when shown as a secondary treatment recommendation'
      />
    ),
    description: (
      <FormattedMessage
        defaultMessage='In person behavioral health appointments available for all T-Mobile employees and dependents. Located on the Overland Park HQ Campus.'
        description='Description for T-Mobile Onsite Health Center with Premise Health providers'
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Book appointment'
        description='Button text to book an appointment with Premise Health'
      />
    ),
    url: 'https://www.mypremisehealth.com/mychart/Authentication/Login',
    modalDescription: (
      <FormattedMessage
        defaultMessage='Available at the Overland Park HQ for T-Mobile employees and dependents. Therapy visits with Premise count toward your Lyra Mental Health Benefits.{lineBreak}{lineBreak}Learn more about the services available through Premise Health.'
        description='Modal description for T-Mobile Onsite Health Center with Premise Health providers'
        values={{
          lineBreak: '\n',
        }}
      />
    ),
  }

  return {
    scheduleResourceCoordinatorCallLink: 'https://go.oncehub.com/T-MobileResourceCoordination',
    treatmentOptions: [
      {
        option: TREATMENT_OPTIONS.ONSITE_THERAPY,
        config: {
          customCopy: premiseHealthOnsiteTherapyConfiguration,
          key: 'premise_health',
        },
        displayRules: {
          // all checks must pass (AND logic)
          showForTiers: [TREATMENT_RECOMMENDATION_TIER.TIER_2, TREATMENT_RECOMMENDATION_TIER.TIER_3],
          showForTreatmentOptions: [
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY,
            TREATMENT_OPTIONS.BLENDED_CARE_THERAPY,
            TREATMENT_OPTIONS.FAMILY_THERAPY,
            TREATMENT_OPTIONS.COUPLES_THERAPY,
            TREATMENT_OPTIONS.ONSITE_THERAPY,
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD,
            TREATMENT_OPTIONS.FAMILY_THERAPY_CHILD,
            TREATMENT_OPTIONS.ALCOHOL_USE_DISORDER,
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_ICAS_PHONE,
            TREATMENT_OPTIONS.INDIVIDUAL_THERAPY_CHILD_ICAS_PHONE,
            'familyTherapyICASPhone',
            'couplesTherapyICASPhone',
          ] as (TREATMENT_OPTIONS_TYPE | 'familyTherapyICASPhone' | 'couplesTherapyICASPhone')[],
          // Eligibility service: checks user attributes from eligibility API
          // Note: Matching is normalized (lowercase, no spaces/commas/dashes)
          // so 'KS - Headquarters, Building 6360' matches 'KS-HeadquartersBuilding6360'
          eligibility: {
            employeeGroup: [
              'KS-Headquarters, Building 6360 OP',
              'KS-Headquarters, Building 6160 OP',
              'KS-HeadquartersBuilding6200',
              'KS-Headquarters, Building 6200 OP',
              'KS-HeadquartersBuilding6220',
              'KS-HeadquartersBuilding6360',
              'KS-HeadquartersBuilding6160',
              'KS-HeadquartersBuilding6Sp',
              'KS-Headquarters, Building 6220 OP',
              'KS - Overland Park Company Store',
              'KS – Magenta Service Center',
            ],
          },
        },
        optionRanking: {
          [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 2,
          [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 1,
          seeMore: 1,
        },
      },
    ],
  }
}
